<template>
  <div>
    <div class="sayfahead">
      <h1>Kısa Mesaj</h1>
      <el-button-group class="float-right">
        <router-link tag="el-button" class="el-button YeniBtn el-button--small"
                     to="/iletisim/sms/gecmis"> Mesaj Geçmişi
        </router-link>
        <router-link tag="button" class="el-button YeniBtn el-button--small"
                     to="/iletisim/sms/bildirim"> Bildirim Merkezi
        </router-link>
      </el-button-group>

    </div>
    <div class="icerik" style="height: calc(100vh - 120px)">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form @submit.prevent.native="Onizleme">
            <div class="SmsIcerik">
              <el-row :gutter="24">
                <el-col :span="20">
                  <el-input ref="mesaj" type="textarea" rows="6" resize="none" v-model="Sms.Icerik"
                            placeholder="Sınırsız mesaj yazabilirsiniz. Normalde 160 karaktere bölünerek ücretlendirilecektir. En az 5 karakter yazabilirsiniz."></el-input>
                  <el-alert :closable="false" type="error" v-if="Sms.Icerik.length>799">Karakter limiti aşıldı
                  </el-alert>
                  <el-alert
                    title="Lütfen borç bilgisinin yazılacağı bölümü Güncel Borç butonuna basarak belirtiniz."
                    type="error"
                    v-if="BorcUyari"
                    :closable="false">
                  </el-alert>
                </el-col>
                <el-col :span="4">
                  <div class="SmsBilgi">
                    <h1 v-if="Sms.Icerik">{{Math.floor((Sms.Icerik.length+5)/160)+1}}</h1>
                    <h1 v-if="!Sms.Icerik">0</h1>
                    <h2 class="tx-IBM">{{this.$store.getters.HizmetBilgi.SmsBaslik}}</h2>
                    <small>Sms Kredisi</small>
                    <small v-if="Sms.Icerik">{{Sms.Icerik.length+5}} Karakter</small>
                    <small v-if="!Sms.Icerik">5 Karakter</small>
                  </div>
                  <el-tag size="mini" class="d-block text-center">Sms Bakiye: <b>{{this.$store.getters.HizmetBilgi.Sms.Kalan}}</b>
                  </el-tag>
                </el-col>

                <el-col :span="24">
                  <el-divider content-position="left">Değişkenler</el-divider>
                  <el-button-group>
                    <el-button v-for="d in Degisken" @click="setDegisken(d.Value)" size="mini" :type="d.type">{{d.Text}}
                    </el-button>

                  </el-button-group>
                  <el-divider content-position="left">Mesaj Kurgusu</el-divider>
                  <el-row :gutter="24">

                    <el-col :span="10">
                      <el-form-item label="Site / Bina" prop="Bina_id">
                        <el-select @change="BinaSecimi()" v-model="Sms.Kurgu.Bina_id" filterable clearable>
                          <el-option-group
                            label="Site Listesi">
                            <el-option
                              v-for="item in Siteler"
                              :key="item.id"
                              :label="item.Adi"
                              :value="item.id">
                            </el-option>
                          </el-option-group>
                          <el-option-group
                            label="Bina Listesi">
                            <el-option
                              v-for="item in Binalar"
                              :key="item.id"
                              :label="item.Adi"
                              :value="item.id">
                            </el-option>
                          </el-option-group>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="14">
                      <el-form-item label="Kişiler" prop="Kisiler">
                        <el-cascader
                          :disabled="!MeskenListe"
                          :options="MeskenListe"
                          v-model="Sms.Kurgu.Kisiler"
                          collapse-tags
                          :props="{ multiple: true }"
                          filterable></el-cascader>
                      </el-form-item>
                    </el-col>

                    <el-col :span="2">
                      <el-form-item label="Grupla" class="Tooltip" prop="Grup">
                        <el-tooltip class="item" effect="dark"
                                    content="Sms telefon numarasına göre gruplanacaksa aktif ediniz" placement="top">
                          <i class="el-icon-info text-primary cursor-pointer"></i>
                        </el-tooltip>
                        <el-switch :disabled="Sms.Kurgu.Borc" v-model="Sms.Kurgu.Grup"></el-switch>
                      </el-form-item>
                    </el-col>

                    <el-col :span="2">
                      <el-form-item label="Malik" class="Tooltip" prop="Borc">
                        <el-tooltip class="item" effect="dark"
                                    content="Sadece Mesken Sahipleri muhatap alınır" placement="top">
                          <i class="el-icon-info text-primary cursor-pointer"></i>
                        </el-tooltip>
                        <el-switch :disabled="Sms.Kurgu.Sakin" v-model="Sms.Kurgu.Malik"></el-switch>
                      </el-form-item>
                    </el-col>

                    <el-col :span="2">
                      <el-form-item label="Sakin" class="Tooltip" prop="Borc">
                        <el-tooltip class="item" effect="dark"
                                    content="Sadece Mesken Kiracıları muhatap alınır" placement="top">
                          <i class="el-icon-info text-primary cursor-pointer"></i>
                        </el-tooltip>
                        <el-switch :disabled="Sms.Kurgu.Malik" v-model="Sms.Kurgu.Sakin"></el-switch>
                      </el-form-item>
                    </el-col>

                    <el-col :span="2">
                      <el-form-item label="Borç" class="Tooltip" prop="Borc">
                        <el-tooltip class="item" effect="dark"
                                    content="Detaylı borç bilgilendirme mesajı ise aktif ediniz" placement="top">
                          <i class="el-icon-info text-primary cursor-pointer"></i>
                        </el-tooltip>
                        <el-switch v-model="Sms.Kurgu.Borc"></el-switch>
                      </el-form-item>
                    </el-col>


                    <el-col :span="10">
                      <el-form-item label="Kategori" prop="Kategori_id">
                        <el-cascader
                          collapse-tags
                          :props="{ multiple: true }"
                          :options="Kategoriler"
                          v-model="Sms.Kurgu.Kategori_id"
                          :disabled="!Sms.Kurgu.Borc"
                          filterable></el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="Minimum Borç" class="Tooltip" prop="Tutar">
                        <el-tooltip class="item" effect="dark"
                                    content="Seçilen Kategorilerden yazılan tutardan yüksekse ilave edilir."
                                    placement="top">
                          <i class="el-icon-info text-primary cursor-pointer"></i>
                        </el-tooltip>
                        <el-input :disabled="!Sms.Kurgu.Borc" v-model="Sms.Kurgu.Tutar"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <hr>
                  <el-alert
                    v-if="this.$store.getters.HizmetBilgi.Sms.Kalan>0 && this.$store.getters.HizmetBilgi.Sms.Kalan<100"
                    :title="'Sms krediniz '+this.$store.getters.HizmetBilgi.Sms.Kalan+' adet kalmıştır. Bakiyeniz - (eksi) ye düşmesi durumda 7 gün içinde sms yüklememeniz durumunda hesabınız duraklatılacaktır.'"
                    type="error"
                    effect="dark"
                    :closable="false">
                  </el-alert>
                  <el-alert
                    v-if="this.$store.getters.HizmetBilgi.Sms.Kalan<1"
                    title="Sms Gönderebilmek için kredi yükleyiniz"
                    type="error"
                    effect="dark"
                    :closable="false">
                  </el-alert>
                  <el-alert
                    v-if="!this.$store.getters.HizmetBilgi.SmsBaslik"
                    title="Sms Gönderebilmek Başlık başvurusu yapınız"
                    type="error"
                    effect="dark"
                    :closable="false">
                  </el-alert>
                  <el-button v-if="this.$store.getters.HizmetBilgi.Sms.Kalan>0 && Sms.Icerik.length<800" type="primary"
                             @click="Onizleme('s')" class="pull-right" size="small">Sms Göndermek için hazırla
                  </el-button>
                  <el-button v-if="this.$store.getters.HizmetBilgi.Sms.Kalan>0 && Sms.Icerik.length<800" type="success"
                             @click="Onizleme('w')" class="pull-left" size="small">Whatsapp Web için hazırla
                  </el-button>


                </el-col>
              </el-row>
            </div>
          </el-form>
        </el-col>
        <el-col :span="6">
          <table class="table table-nohover">
            <thead>
            <tr>
              <th>Şablonlar</th>
              <th class="text-right" v-if="Yetki">
                <el-button class="float-right" @click="SablonModal()" size="mini" type="primary">Şablon ekle
                </el-button>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="Sablon in Sablonlar">
              <td>
                <el-tooltip v-if="!Sablon.Tip" class="item" effect="dark" content="Şablonu Uygula"
                            placement="top"><a @click="Sms.Icerik=Sablon.Icerik"><i class="feather-message-square"></i></a></el-tooltip>
                {{Sablon.Adi}}
              </td>

              <td class="text-right" v-if="Yetki">
                <el-tooltip class="item" effect="dark" content="Düzenle"
                            placement="top">
                  <a href="#" @click="SablonDuzenle(Sablon)" class="text-info mr-1"> <i
                    class="feather-edit-2 tableibtn text-primary"></i></a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark"
                            content="Sil"
                            placement="top">
                  <a href="#" v-if="!Sablon.Tip" @click="SilOnay(Sablon.id)" class="text-danger"> <i
                    class="feather-trash tableibtn text-danger"></i></a>
                </el-tooltip>
              </td>
            </tr>
            </tbody>
          </table>
          <el-form v-if="SablonForm" class="BilgiForm" :rules="SablonHata" :model="Sablon"
                   @submit.prevent.native="SablonKaydet"
                   ref="SablonForm">
            <h2>
              {{Sablon.Baslik}}
              <a @click="SablonForm=false" class="ModalKapat"><i class="el-icon-close"></i></a>
            </h2>
            <el-row :gutter="24">
              <el-col :span="12" v-if="!Sablon.Tip">
                <el-form-item label="Site / Bina" prop="Bina_id">
                  <el-select v-model="Sablon.Bina_id" filterable size="mini" clearable>
                    <el-option-group
                      label="Site Listesi">
                      <el-option
                        v-for="item in Siteler"
                        :key="item.id"
                        :label="item.Adi"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                    <el-option-group
                      label="Bina Listesi">
                      <el-option
                        v-for="item in Binalar"
                        :key="item.id"
                        :label="item.Adi"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!Sablon.Tip">
                <el-form-item label="Başlık" prop="Adi">
                  <el-input size="mini" v-model="Sablon.Adi">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="İçerik" prop="Icerik">
                  <el-input size="mini" type="textarea" rows="5" ref="SablonIcerik" v-model="Sablon.Icerik">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="!Sablon.Tip">
                <el-divider content-position="left">Değişkenler</el-divider>
                <el-button-group>
                  <el-button v-for="d in Degisken" @click="setSablonDegisken(d.Value)" size="mini" :type="d.type">
                    {{d.Text}}
                  </el-button>
                </el-button-group>
                <hr>
              </el-col>
              <el-col :span="24" v-if="Sablon.Tip==1">
                <el-divider content-position="left">Değişkenler</el-divider>
                <el-button-group>
                  <el-button v-for="d in BorcDegisken" @click="setSablonDegisken(d.Value)" size="mini" :type="d.type">
                    {{d.Text}}
                  </el-button>
                </el-button-group>
                <hr>
              </el-col>
            </el-row>
            <button type="button" @click="SablonKaydet"
                    class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">Şablon Kaydet
            </button>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      v-if="OnIzleModal"
      :title="Sms.Kurgu.Tur=='s'?'Kısa Mesaj Önizlemesi':'Whatsapp Web Şablonu'"
      :visible.sync="OnIzleModal"
      width="90%">
      <el-button type="primary" size="mini" v-if="!lo && Sms.Kurgu.Tur=='s'" class="float-left borcmodalbuton"
                 @click="MesajGonder">
        İçerikleri Onayla ve Mesajları Gönder
      </el-button>
      <Yukleniyor :data="lo"></Yukleniyor>
      <a @click="OnIzleModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <table class="table table-xs">
        <thead>
        <tr>
          <th width="100">Bina</th>
          <th width="100">Kişi Adı</th>
          <th width="100">Telefon No.</th>
          <th width="50">Kredi</th>
          <th>Mesaj İçeriği</th>
          <th width="10"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="m" v-for="(m,index) in MesajIcerik">
          <td>{{m.Bina}}</td>
          <td>{{m.AdSoyad}}</td>
          <td>{{m.Telefon}}</td>
          <td>{{m.Kredi}} Kredi</td>
          <td><input type="text" v-model="m.Icerik"></input></td>
          <td>
            <a v-if="Sms.Kurgu.Tur=='s'" href="#" @click="MesajIcerik.splice(index, 1)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>
            <a v-if="Sms.Kurgu.Tur=='w'" href="#" @click="Whatsapp(m)" class="text-success">
              <img src="https://cdn.mudu.pro/Design/whatsapp.svg" width="25">
            </a>
          </td>
        </tr>
        </tbody>
      </table>

    </el-dialog>

  </div>
</template>

<script>

  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: true,
        Sms: {
          Icerik: '',
          Kurgu: {
            Malik: false,
            Sakin: false,
            Borc: false,
            Grup: false,
            Kategori_id: null,
            Tutar: null,
            Bina_id: null,
            Kisiler: null,
            Tur: 's'

          }
        },
        BorcUyari: false,
        Bilgi: {
          Karakter: 5,
          Kredi: 0
        },
        MesajIcerik: [],
        Kategoriler: null,
        OnIzleModal: false,
        Siteler: null,
        Binalar: null,
        MeskenListe: null,
        Baslik: null,
        Kredi: 0,
        SablonForm: false,
        Sablonlar: [],
        Sablon: {
          Adi: null,
          Icerik: null,
          id: null,
          Baslik: null,
          Bina_id: null
        },
        SablonHata: {
          Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Icerik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        Degisken: [
          {Text: "Ad Soyad", Value: '[AdSoyad] ', type: 'default'},
          {Text: "Bina Adı", Value: '[Bina] ', type: 'default'},
          {Text: "Kat", Value: '[Kat] ', type: 'default'},
          {Text: "Mesken No", Value: '[kNo] ', type: 'default'},
          {Text: "OİM Şifresi", Value: '[Parola] ', type: 'default'},
          {Text: "Güncel Borç", Value: '[Borc] ', type: 'default'},
        ],
        BorcDegisken: [
          {Text: "Ad Soyad", Value: '[AdSoyad] ', type: 'default'},
          {Text: "Bina Adı", Value: '[Bina] ', type: 'default'},
          {Text: "Mesken No", Value: '[kNo] ', type: 'default'},
          {Text: "Kategori", Value: '[Kategori] ', type: 'default'},
          {Text: "Son Ödeme Tarihi", Value: '[SonOdeme] ', type: 'default'},
          {Text: "Borç Tutar", Value: '[Tutar] ', type: 'default'},
        ],

      }
    },
    methods: {
      Whatsapp(m, index) {
        this.MesajIcerik.splice(index, 1);
        var Url = "https://api.whatsapp.com/send?phone=" + m.aKodu + m.Telefon + "&text=" + m.Icerik;
        window.open(Url, "MsgWindow", "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=400,height=400");
        //console.log(m);
      },
      MesajGonder() {
        this.$confirm(this.MesajIcerik.length + " kişiye içeriklerini düzenlediğiniz smsler gönderilecektir. İşlemler anlık olarak operatörlere iletilecek olup iptal ve durdurma imkanınız olmayacaktır.", "Sms gönderimini onaylıyormusunuz?", {
          confirmButtonText: "İçeriği ve Kişileri Onaylıyorum",
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.OnayliMesajGonder();
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },

      OnayliMesajGonder() {
        this.lo = true;
        this.$store.dispatch("Post", {
          ...this.MesajIcerik,
          path: 'iletisim/sms/gonder'
        })
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              if (response.Hata) this.hata = response.Hata;
              this.OnIzleModal = false;
              this.Sms.Icerik = "";
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      },
      SablonGetir() {
        this.$store.dispatch("Get", {path: 'iletisim/sablon/' + this.Sms.Kurgu.Bina_id})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Sablonlar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.SablonForm = false;
        this.Sablon = {
          Adi: null,
          Icerik: null,
          id: null,
          Bina_id: null,
          Baslik: 'Şablon Ekle'
        }
      },
      BinaSecimi() {
        this.MeskenGetir();
        this.SablonGetir();
      },
      MeskenGetir() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/kisi/liste/b/' + this.Sms.Kurgu.Bina_id})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.MeskenListe = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
      Onizleme(Tur) {
        this.Sms.Kurgu.Tur = Tur;
        if (this.Sms.Icerik) {

          this.lo = true;
          this.$store.dispatch("Post", {
            ...this.Sms,
            path: 'iletisim/sms/onizleme'
          })
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.OnIzleModal = true;
                this.MesajIcerik = response.SmsIcerik;
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        } else {
          this.$message.error("Sms içeriği boş bırakılamaz");
        }

      },
      setDegisken(val) {
        this.Sms.Icerik = this.Sms.Icerik + ' ' + val;
        this.$refs.mesaj.focus();
      },
      setSablonDegisken(val) {
        this.Sablon.Icerik = this.Sablon.Icerik + ' ' + val;
        this.$refs.SablonIcerik.focus();
      },
      SablonKaydet() {
        this.$refs['SablonForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            if (this.Sablon.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.Sablon,
                path: 'iletisim/sablon/' + this.Sablon.id
              })
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$message.success(response.Mesaj);
                    this.SayfaYukle();
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            } else {
              //EKLE
              this.$store.dispatch("Post", {
                ...this.Sablon,
                path: 'iletisim/sablon'
              })
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$message.success(response.Mesaj);
                    this.SayfaYukle();
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            }

          }
        });
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'yonetim/site'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Siteler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

        this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kategoriler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

        this.SablonGetir();

      },
      SablonDuzenle(veri) {
        this.Sablon = veri;
        this.Sablon.Baslik = 'Şablon Düzenle';
        this.SablonForm = true;
      },
      SablonModal() {
        this.SablonForm = true;
        this.Sablon = {
          Adi: null,
          Icerik: null,
          id: null,
          Bina_id: null,
          Baslik: 'Şablon Ekle'
        }

      },
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.lo = false;
        this.$store.dispatch("Delete", {...this.Form, path: 'iletisim/sablon/' + id})
          .then(response => {
            this.lo = true;
            if (response.Durum == "OK") {
              this.SablonForm = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
    },
    created() {

      this.Yetki = this.$store.getters.Yetki.iletisim == 2 ? true : false;
      this.SayfaYukle();
      if (this.$store.getters.BinaBilgi) {
        this.Sms.Kurgu.Bina_id = this.$store.getters.BinaBilgi.id;
        this.MeskenGetir();
      }


    },
    computed: {
      Kurgu() {
        return this.Sms.Kurgu.Borc;
      }
    },
    watch: {
      Kurgu() {
        if (this.Sms.Kurgu.Borc) {
          this.BorcUyari = true;
          this.Sms.Kurgu.Grup = false;
        } else {
          this.BorcUyari = false;
          this.Sms.Kurgu.Kategori_id = null;
          this.Sms.Kurgu.Tutar = null;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iletisim/sms/gonder.vue